// Module
var code = `<customer-page>
  <customer-loan-create-details ng-form="\$ctrl.loanForm"
                                loan="\$ctrl.loanInput"
                                loan-type-id="\$ctrl.loanInput.loanTypeId"
                                edit-mode="true">
  </customer-loan-create-details>

  <div class="summary-actions">
    <button type="button" class="btn btn-warning"
            ng-click="\$ctrl.redirectBack()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            ng-click="\$ctrl.renew()"
            ng-disabled="\$ctrl.loanForm.\$invalid">
      Renew
    </button>
  </div>
</customer-page>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/new-loan/page/renewal/customer-loan-renewal-page.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;